import { useContext } from 'react';
import { CnFormArrayBaseItemContext } from '../context';
export var useIndex = function (index) {
    var ctx = useContext(CnFormArrayBaseItemContext);
    return ctx ? ctx.index : index;
};
